<template>
  <div id="app">
    <router-view />
    
    <!-- <footerBar></footerBar> -->
  </div>
</template>

<script>
import footerBar from "@/components/footer";
export default {
  name: "App",
  components: { footerBar },
  created(){
    this.postMessage()
  },
};
</script>

<style>
@import './css/common.css';

</style>



// WEBPACK FOOTER //
// src/App.vue